import React, { useEffect, useState } from "react";
import GroupMember from "./Group Member List/GroupMember";
// css comes in adminMember.css
import axios from "../../../../../../axios";
import { IP } from "../../../../../../internalServer";

const GroupsMember = ({
  group,
  communityId,
  inEditingMode,
  setDeletingAllMembersDetails,
  deletingAllMembersDetails,
}) => {
  const { deletingGroups } = deletingAllMembersDetails;
  const [click, setClick] = useState(false);
  const [memberCount, setMemberCount] = useState();
  useEffect(() => {
    const getMemberCount = async () => {
      let res = await axios.get(
        `/api/v1/community/${communityId}/groupId/${group?.id}/getMember`
      );
      res && setMemberCount(res.data.data.members.length);
    };
    getMemberCount();
  }, []);

  const handleDeleteMember = () => {
    if (deletingGroups.includes(group.id)) {
      const newGroupsList = deletingGroups.filter((a) => a !== group.id);
      setDeletingAllMembersDetails((prevState) => ({
        ...prevState,
        deletingGroups: newGroupsList,
      }));
    } else {
      setDeletingAllMembersDetails((prev) => ({
        ...prev,
        deletingGroups: [...prev.deletingGroups, group.id],
      }));
    }
  };

  return (
    <>
      <div className="mt-1 col-12 p-0 d-flex align-items-center justify-content-between ">
        <div className=" p-0 gap-2 d-flex align-items-center">
          <div className="member_account_img d-flex align-items-center justify-content-center">
            {!group?.profile_picture ? (
              <span>10</span>
            ) : (
              <img
                src={`${IP}${group?.profile_picture.substring(
                  group?.profile_picture.indexOf("/")
                )}`}
                alt=""
              />
            )}
          </div>
          <span className="">{group?.name}</span>
        </div>
        <div className=" gap-3 d-flex">
          <div className="member_btn_box">{memberCount} Member</div>

          <img
            className="downArrow"
            src="/images/Down arrow.svg"
            alt=""
            onClick={() => setClick(!click)}
          />
          {inEditingMode && (
            <>
              {!deletingGroups.includes(group.id) ? (
                <img
                  onClick={handleDeleteMember}
                  src="/images/Dustbin.svg"
                  alt=""
                />
              ) : (
                <img
                  onClick={handleDeleteMember}
                  src="/images/redDustbin.svg"
                  alt=""
                />
              )}
            </>
          )}
        </div>
      </div>
      {click && (
        <>
          <GroupMember
            group={group}
            setDeletingAllMembersDetails={setDeletingAllMembersDetails}
            deletingAllMembersDetails={deletingAllMembersDetails}
            communityId={communityId}
            inEditingMode={inEditingMode}
          />
        </>
      )}
    </>
  );
};

export default GroupsMember;
